import { render, staticRenderFns } from "./ShowMail.vue?vue&type=template&id=4857cd1f"
import script from "./ShowMail.vue?vue&type=script&lang=js"
export * from "./ShowMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports